import {createContext} from 'react'

/**
 * A React context for sharing the `composing` state of the editor.
 */

export const ComposingContext = createContext(false)
